import React, { useEffect, useState } from 'react';
import { Scale, RotateCcw } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { useAuth } from '../../context/AuthContext';
import { TrialBoard } from './TrialBoard';
import { TrialSetup } from './TrialSetup';
import { TrialHistory } from './TrialHistory';
import { TrialTeamPanel } from './TrialTeamPanel';

export const TrialSimDialog = ({ matter, open, onOpenChange }) => {
  const { api } = useAuth();
  const [s, setS] = useState(null);
  const [tab, setTab] = useState('play');
  useEffect(() => { if (open) api.get(`/trial-sim/matters/${matter.id}/latest`).then((r) => r.data.session && setS(r.data.session)).catch(() => {}); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const openSim = async (id) => { const r = await api.get(`/trial-sim/${id}`); setS(r.data.session); setTab('play'); };
  const reload = () => s && openSim(s.id).then(() => setTab('team'));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="trial-sim-dialog" className="bg-slate-950 border-slate-700 text-white max-w-5xl max-h-[92vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="pr-8 flex items-center gap-2"><Scale className="h-5 w-5 text-amber-400" />Simulación de juicio completo · {matter.title}</DialogTitle>
          <DialogDescription title={s?.map?.procedimiento} className="text-slate-400 line-clamp-2">{s?.map?.procedimiento || 'La IA hace de juez y de abogado contrario en cada etapa del proceso de tu país.'}</DialogDescription>
        </DialogHeader>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-slate-900">
            <TabsTrigger data-testid="trial-tab-play" value="play">Simulación</TabsTrigger>
            <TabsTrigger data-testid="trial-tab-history" value="history">Historial</TabsTrigger>
            <TabsTrigger data-testid="trial-tab-team" value="team" disabled={!s}>Equipo{s?.team?.length ? ` (${s.team.length + 1})` : ''}</TabsTrigger>
          </TabsList>
          <TabsContent value="play" className="mt-4">
            {!s ? <TrialSetup matter={matter} onStarted={(r) => { if (r) { setS(r); setTab('play'); } }} /> : <TrialBoard s={s} setS={setS} sidebarExtra={
              <button data-testid="trial-restart-btn" onClick={() => setS(null)} className="flex items-center gap-1 text-xs text-slate-400 hover:text-white"><RotateCcw className="h-3 w-3" />Nueva simulación</button>} />}
          </TabsContent>
          <TabsContent value="history" className="mt-4"><TrialHistory matterId={matter.id} currentId={s?.id} onOpen={openSim} /></TabsContent>
          <TabsContent value="team" className="mt-4">{s && <TrialTeamPanel s={s} reload={reload} />}</TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
